<script>
import {
  createGenerateChart,
  createDestoryChart,
  createLoadDataChart,
  unLoadDataChart,
} from './chartMethods';

export default {
  name: 'billboard-chart',
  props: {
    options: {
      type: Object,
      required: true,
    },
  },
  created() {
    // instance methods
    this.generateChart = createGenerateChart(this);
    this.destoryChart = createDestoryChart(this);
    this.loadDataChart = createLoadDataChart(this);
    this.unLoadDataChart = unLoadDataChart(this);
  },
  mounted() {
    this.$chart = this.generateChart();
  },
  unmounted() {
    this.destoryChart();
  },
  watch: {
    'options.data': {
      deep: true,
      handler(newData) {
        this.loadDataChart(newData);
      },
    },
  },
};
</script>

<template>
<div class='v-bb-chart'></div>
</template>



// WEBPACK FOOTER //
// src/modules/chart/components/Chart/index.vue